import BaseAnalysisService from './BaseAnalysisService';
import env from 'environment';

class CrifAnalysisService
    extends BaseAnalysisService {
  constructor() {
    super({
      analysisType: 'crif',
      requireAnalysisTypeId: false,
    });
  }
}

const service = new CrifAnalysisService();

export default service;
